import service from '@/services/roles'
export default {
  methods: {
    async doDelete(list) {
      const response = await service.deleteRole({ ids: list.map(item => item.id) })
      if (response?.data?.error?.type === 200) {
        return {
          result: response.data.data.result,
          message: null
        }
      } else {
        return {
          result: false,
          message: response?.data?.error?.message || 'The error has occurred during execution of the operation.'
        }
      }
    }
  }
}
